import { authReducers } from './reducers/authReducers'
import {thunk} from 'redux-thunk';
import { combineReducers, applyMiddleware, compose, createStore } from 'redux';
import { brandReducers } from './reducers/brandReducers';
import { voucherListReducer } from './reducers/voucherListReducers';
import { userListReducer } from './reducers/userListReducers';
import { orderListReducer } from './reducers/orderReducers';
import { transactionReducer } from './reducers/transactionReducers';
import { negotiationListReducer } from "./reducers/negotiationReducers";

const appReducer = combineReducers({
    auth: authReducers,
    brand:brandReducers,
    voucherList: voucherListReducer,
    userList:userListReducer,
    orderList:orderListReducer,
    transactionList:transactionReducer,
    negotiationList: negotiationListReducer,
})

const reducer = (state, action) => {
    if (action.type === 'RESET_USER') {
        return appReducer(undefined, action)
    }

    return appReducer(state, action)
}


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [thunk];

const store = createStore(reducer, composeEnhancers(
    applyMiddleware(...middleware)
));

export default store;